import { firstBy } from 'thenby'
import handleDSOperation from '../handleDSOperation'
import mergeArrayAndCombineQty from '../helpFunc/mergeArrayAndCombineQty'
import getDeductedItems from '../helpFunc/getDeductedItems'
import dsCreateSpoScheds from './dsCreateSpoScheds'

const dsUpdateSPOQtyAndSPOSchedAfterCreateReceivings = async (items) => {
  const mergedArr = mergeArrayAndCombineQty(items, ['hpn', 'poNumber'], ['qty'])
  // console.log('mergedArr', mergedArr)

  const arrOfarrUpdatedPo = await Promise.all(
    mergedArr.map(async (receivingItem) => {
      const poItems = await handleDSOperation('spo', 'query', {
        version: { predicate: 'eq', value: 0 },
        hpn: { predicate: 'eq', value: receivingItem.hpn },
        poNumber: { predicate: 'eq', value: receivingItem.poNumber },
        openQty: { predicate: 'gt', value: 0 },
      })

      poItems.sort(firstBy('reqSched').thenBy('openQty'))

      return getDeductedItems(receivingItem, poItems, 'qty', 'openQty')
    }),
  )
  const arrOfUpdatedPo = [].concat.apply([], arrOfarrUpdatedPo)

  // console.log('arrOfUpdatedPo', arrOfUpdatedPo)
  // console.log('4444444444444444444444')

  await Promise.all(
    arrOfUpdatedPo.map(async (x) => {
      await handleDSOperation(null, 'update', {
        id: x.id,
        openQty: x.openQty - x.changedQty,
      })
    }),
  )

  // ATTENTION UPDATE SPO SCHEDULE

  const arrOfarrUpdatedSpoSched = await Promise.all(
    arrOfUpdatedPo
      .map((y) => ({ ...y, qty: y.changedQty }))
      .map(async (x) => {
        const getSchedItems = await handleDSOperation('spoSched', 'query', {
          version: { predicate: 'eq', value: 0 },
          hpn: { predicate: 'eq', value: x.hpn },
          poNumber: { predicate: 'eq', value: x.poNumber },
          openQty: { predicate: 'gt', value: 0 },
        })
        // console.log('getSchedItems', getSchedItems)
        getSchedItems.sort(firstBy('estSched').thenBy('openQty'))

        const isSchedule = true

        const items = getDeductedItems(
          x,
          getSchedItems,
          'qty',
          'openQty',
          isSchedule,
        )
        return items.map((x) => ({ ...x, openQty: x.openQty - x.changedQty }))
      }),
  )
  const arrOfUpdatedSpoSched = [].concat.apply([], arrOfarrUpdatedSpoSched)
  // ATTENTION UPDATE SPO SCHEDULE
  await dsCreateSpoScheds(arrOfUpdatedSpoSched)
  // console.log('555555555555555555555555')
}

export default dsUpdateSPOQtyAndSPOSchedAfterCreateReceivings
